// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-content[data-v-def0c4b2]{display:grid;grid-template-columns:1fr}.modal-link[data-v-def0c4b2]{width:100%;text-decoration:none}.text-block[data-v-def0c4b2]{margin-bottom:1.5rem}@media(min-width: 768px){.modal-content[data-v-def0c4b2]{grid-template-columns:3fr 2fr;grid-gap:4rem}.modal-content.single-column[data-v-def0c4b2]{grid-template-columns:1fr}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
